<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"

    :showExpand="true"
    :customExpandIcon="true"
    @row-clicked="handleRowClicked"
    class="row-pointer"
    :containSearchBar="false"
  >

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template v-slot:expand="{ item, headers }">
      <td :colspan="headers.length" :class="'px-0 px-sm-2 px-md-6 mt-3 ' + ($vuetify.breakpoint.smAndDown ? 'v-data-table__mobile-row': '')">
        <ExitMovementItemIndex
          :loading="false"
          :storageItems.sync="item.exitMovementItems"
          class="mt-6"
          :readOnly="true"
        />
      </td>
     
    </template>

    <template v-slot:expandColumn="{ item, isExpanded, expand }">
      <v-btn text color="primary" v-if="!isExpanded">Ver Insumos</v-btn>
      <v-btn text color="primary" v-if="isExpanded"><v-icon left>mdi-eye-off</v-icon>Insumos</v-btn>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
// import New from "@models/operations/seed_plot_operations/new.vue";
import Edit from "@models/operations/seed_plot_operations/edit.vue";
import ExitMovementItemIndex from "./exit_movement_item_index.vue";
// import Delete from "@models/operations/seed_plot_operations/delete.vue";
// import PlanningOperationShow from "@models/operations/planning_seed_plot_operations/edit.vue"

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code"},
        { text: "Tipo de Operação", align: "left", sortable: true, value: "operationType.name"},
        // { text: "Cultura(s)", align: "left", sortable: true, value: "cultureNames"},
        // { text: "Lotes(antigo)", align: "left", sortable: true, value: "lots", filter_value: "lotsFilter"},
        // { text: "Lotes", align: "left", sortable: true, value: "newLots", filter_value: "newLotsFilter"},
        // { text: "Insumos", align: "left", sortable: true, value: "varietyNames"},
        // { text: "Estufa(s)", align: "left", sortable: true, value: "storageNames"},
        // { text: "Área Total", align: "left", sortable: true, value: "periodsTotalArea" },
        { text: "Data da Operação", align: "left", sortable: true, value: "operationDate" },
        // { text: "Duração Total", align: "left", sortable: true, value: "activitiesTotalDuration" },
        // { text: "Planejamento", align: "left", sortable: false, value: "link" },
        { text: "Insumos", align: "left", sortable: false, value: "data-table-expand" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      // maskFields: [
      //   { field: 'operationDate', mask: 'date'},
      //   { field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }, 
      //   { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
      // ],
      infoHeaders: [
        { field: 'varietyNames', info: 'Variedades, fertilizantes, agrotóxicos e biológicos consumidos nas operações. *Em operações de destinar semeios as variedades indicadas são as geradas.' },
        { field: 'lots', info: 'Lotes semeados, em estufa ou aplicados'},
      ],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    entryId: 0,
    modelNameSingular: {
      type: String,
      default: "Operação"
    },
    modelNamePlural: {
      type: String,
      default: "Operações"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    // New: New,
    Edit: Edit,
    ExitMovementItemIndex: ExitMovementItemIndex,
    // Delete: Delete,
    // PlanningOperationShow: PlanningOperationShow
  },
  created() {
    this.loadServerEntries();
  },
  computed: {
    maskFields() {
      return [
        { field: 'operationDate', mask: 'date'},
        ... this.$vuetify.breakpoint.smAndDown ? [] : [{ field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }], 
        { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
      ]
    }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_SEED_PLOT_OPERATIONS_FROM_SALE_LOT,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            },
            id: this.entryId,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.executionOperations = response.data.groundContext.allExecutionOperations;
          // console.log("All executionOperations", response.data.groundContext.executionOperationsIndex);
          this.indexItems = response.data.groundContext.seedPlotOperationsIndexFromSaleLot.seedPlotOperations; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.groundContext.seedPlotOperationsIndexFromSaleLot.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.groundContext.seedPlotOperationsIndexFromSaleLot.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.groundContext.seedPlotOperationsIndexFromSaleLot.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    handleRowClicked: function(rowArguments) {
      // console.log("row click", rowArguments);
      if (rowArguments && rowArguments[1]) {
        rowArguments[1].expand(!rowArguments[1].isExpanded);
      }
    },
  }
};

const LOAD_ALL_SEED_PLOT_OPERATIONS_FROM_SALE_LOT = gql `
  query($input: IndexInputObject!, $id: ID!) {
    groundContext {
      seedPlotOperationsIndexFromSaleLot(input: $input, id: $id){
        count
        typeOperators
        serverFields
        seedPlotOperations {
          id
          code
          operationDate
          operationType{
            name
          }
          exitMovementItems{
            itemId
            item{
              name
            }
            quantity
            packaging{
              packagingType{
                name
              }
              name
              basicUnitName
              size              
            }
            exitMovementItemLotsAttributes{
              newName
              quantity
              packagingQuantity
            }
          }
        }
      }
    }
  }
`;

</script>

<style scoped></style>
